module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Medium-178f6928ceafac93514bbaae9cea7200.woff2";